/**
 * Encodes a string using Base64 encoding.
 * @param {string} str - The string to encode.
 * @returns {string} - The Base64 encoded string.
 */
export const encodeUrl = (str) => {
  try {
    return btoa(str);
  } catch (e) {
    console.error("Encoding failed: ", e);
    return null;
  }
};

/**
 * Decodes a Base64 encoded string.
 * @param {string} encodedStr - The Base64 encoded string.
 * @returns {string} - The decoded string.
 */
export const decodeUrl = (encodedStr) => {
  try {
    return atob(encodedStr);
  } catch (e) {
    console.error("Decoding failed: ", e);
    return null;
  }
};
